import React, { useState } from "react";
import { abbreviateSha } from "../reviews/reviewDisplay";

export default function CopyableSha({ sha, label = "commit" }) {
  const [copied, setCopied] = useState(false);
  if (!sha) return null;
  return (
    <span className="rr-row">
      <span className="rr-sha">{abbreviateSha(sha)}</span>
      <button
        type="button"
        className="rr-text-button"
        aria-label={`Copy ${label} ${sha}`}
        onClick={async () => {
          try {
            await navigator.clipboard.writeText(sha);
            setCopied(true);
          } catch {
            setCopied(false);
          }
        }}
      >
        {copied ? "Copied" : "Copy"}
      </button>
    </span>
  );
}
